<template>
<div class="main-app-bar">
  <v-app-bar app flat color="#fff" height="50px">
    <v-container class="py-0 fill-height">
      <v-app-bar-nav-icon v-if="showNav" class="d-flex d-sm-none" @click="drawer = !drawer"></v-app-bar-nav-icon>
      <div class="logo-container">
        <v-avatar size="32">
          <img src="/logo.png" alt="logo"/>
        </v-avatar>
      </div>
      <div v-if="user">
        <v-tabs align-with-title class="d-none d-sm-flex" :value="activeTab">
          <v-tab :to="{ name: 'calendar' }">Calendar</v-tab>

          <template v-if="user.admin">
            <v-tab :to="{ name: 'overview' }">Overview</v-tab>

            <v-menu offset-y open-on-hover close-delay="100">
              <template v-slot:activator="{ on, attrs }">
                <v-tab v-bind="attrs" v-on="on">
                  Jobs <v-icon small class="ml-1">mdi-chevron-down</v-icon>
                </v-tab>
              </template>
              <v-list dense>
                <v-list-item :to="{ name: 'job-list' }">
                  <v-list-item-title>Jobs List</v-list-item-title>
                </v-list-item>
                <v-list-item :to="{ name: 'job-times' }">
                  <v-list-item-title>Job Times</v-list-item-title>
                </v-list-item>
                <v-list-item :to="{ name: 'job-costs' }">
                  <v-list-item-title>Job Costs</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>

            <v-menu offset-y open-on-hover close-delay="100">
              <template v-slot:activator="{ on, attrs }">
                <v-tab v-bind="attrs" v-on="on">
                  Payroll <v-icon small class="ml-1">mdi-chevron-down</v-icon>
                </v-tab>
              </template>
              <v-list dense>
                <v-list-item :to="{ name: 'staff-payroll' }">
                  <v-list-item-title>Staff Payroll</v-list-item-title>
                </v-list-item>
                <v-list-item :to="{ name: 'freelance-payroll' }">
                  <v-list-item-title>Freelance Payroll</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>

            <v-menu offset-y open-on-hover close-delay="100">
              <template v-slot:activator="{ on, attrs }">
                <v-tab v-bind="attrs" v-on="on">
                  Admin <v-icon small class="ml-1">mdi-chevron-down</v-icon>
                </v-tab>
              </template>
              <v-list dense>
                <v-list-item :to="{ name: 'users' }">
                  <v-list-item-title>Users</v-list-item-title>
                </v-list-item>
                <v-list-item :to="{ name: 'analysis' }">
                  <v-list-item-title>Analysis</v-list-item-title>
                </v-list-item>
                <v-list-item :to="{ name: 'stock-items' }">
                  <v-list-item-title>Stock Items</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
            <v-menu offset-y open-on-hover close-delay="100">
              <template v-slot:activator="{ on, attrs }">
                <v-tab v-bind="attrs" v-on="on">
                  Website <v-icon small class="ml-1">mdi-chevron-down</v-icon>
                </v-tab>
              </template>
              <v-list dense>
                <v-list-item :to="{ name: 'website-projects' }">
                  <v-list-item-title>Projects</v-list-item-title>
                </v-list-item>
                <v-list-item :to="{ name: 'website-meta' }">
                  <v-list-item-title>Meta</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>
          <template v-else>
            <v-tab :to="{ name: 'job-list' }">Jobs</v-tab>
            <v-tab v-if="user.status === 'freelance'" :to="{ name: 'freelance-payroll' }">Invoices</v-tab>
          </template>
        </v-tabs>
      </div>
      <v-spacer></v-spacer>
      <template v-if="user">
        {{ user.name }}
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <span v-bind="attrs" v-on="on">
              <v-icon>mdi-dots-vertical</v-icon>
            </span>
          </template>
          <v-list flat class="text-right">
            <v-list-item>
              <v-list-item-title>
                <v-btn text @click="settingsOpen = true">Settings</v-btn>
              </v-list-item-title>
            </v-list-item>
            <v-list-item>
              <v-list-item-title>
                <v-btn text @click="logout">Logout</v-btn>
              </v-list-item-title>
            </v-list-item>
            <div class="text-left grey--text ml-4">{{ version }}</div>
          </v-list>
        </v-menu>
      </template>
    </v-container>
    <v-dialog v-model="settingsOpen" max-width="640px">
      <user-settings @close="settingsOpen = false"></user-settings>
    </v-dialog>
  </v-app-bar>
  <v-navigation-drawer v-model="drawer" absolute temporary width="160px">
    <v-list nav dense>
      <v-list-item v-for="link in mobileLinks" :key="link.name" :to="{ name: link.route }">
        <v-list-item-title>{{ link.name }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</div>
</template>

<script>
import { mapState } from 'vuex'
import UserSettings from '../user/UserSettings'

export default {
  name: 'Header',
  components: { UserSettings },
  data() {
    return {
      drawer: false,
      settingsOpen: false,
      version: process.env.VUE_APP_VERSION
    }
  },
  computed: {
    ...mapState(['user']),
    activeTab() {
      const name = this.$route.name
      if (name === 'calendar') return 0
      if (name === 'overview') return 1
      if (['job-list', 'job-times', 'job-costs', 'load-list'].includes(name)) return 2
      if (['staff-payroll', 'freelance-payroll'].includes(name)) return 3
      if (['users', 'analysis', 'stock-items'].includes(name)) return 4
      if (['website-projects', 'website-meta'].includes(name)) return 5
      return null
    },
    mobileLinks() {
      if (!this.user) return []
      const links = [{ name: 'Calendar', route: 'calendar' }]
      if (this.user.admin) {
        links.push(
          { name: 'Overview', route: 'overview' },
          { name: 'Jobs List', route: 'job-list' },
          { name: 'Job Times', route: 'job-times' },
          { name: 'Job Costs', route: 'job-costs' },
          { name: 'Staff Payroll', route: 'staff-payroll' },
          { name: 'Freelance Payroll', route: 'freelance-payroll' },
          { name: 'Users', route: 'users' },
          { name: 'Analysis', route: 'analysis' },
          { name: 'Stock Items', route: 'stock-items' },
          { name: 'Website Projects', route: 'website-projects' }
        )
      } else {
        links.push({ name: 'Jobs', route: 'job-list' })
        if (this.user.status === 'freelance') {
          links.push({ name: 'Invoices', route: 'freelance-payroll' })
        }
      }
      return links
    },
    showNav() {
      return this.$route.name !== 'login'
    }
  },
  methods: {
    logout() {
      this.$store.commit('logout')
      this.$router.push({ name: 'login' })
    }
  }
}
</script>

<style scoped lang="scss">
div.container {
  height: unset;
}

div.logo-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: 1rem;

  span {
    font-size: 0.7rem;
    color: #555;
  }
}

a.v-tab {
  min-width: unset;
  padding: 0 10px;

  @media (max-width: 960px) {
    font-size: 0.8rem;
    padding: 0 5px;
  }
}
</style>

<style>
div.main-app-bar header .v-toolbar__content {
  padding: 0;
}
</style>
